/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IntegerOptionFromJSON, IntegerOptionToJSON, MetaDataFromJSON, MetaDataToJSON, StringOptionFromJSON, StringOptionToJSON, } from './';
export function PlayerOptionsResponseFromJSON(json) {
    return PlayerOptionsResponseFromJSONTyped(json, false);
}
export function PlayerOptionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'resolutions': !exists(json, 'resolutions') ? undefined : (json['resolutions'].map(StringOptionFromJSON)),
        'orientations': !exists(json, 'orientations') ? undefined : (json['orientations'].map(StringOptionFromJSON)),
        'rotations': !exists(json, 'rotations') ? undefined : (json['rotations'].map(IntegerOptionFromJSON)),
        'formats': !exists(json, 'formats') ? undefined : (json['formats'].map(StringOptionFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'screenPositions': !exists(json, 'screenPositions') ? undefined : (json['screenPositions'].map(StringOptionFromJSON))
    };
}
export function PlayerOptionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'resolutions': value.resolutions === undefined ? undefined : (value.resolutions.map(StringOptionToJSON)),
        'orientations': value.orientations === undefined ? undefined : (value.orientations.map(StringOptionToJSON)),
        'rotations': value.rotations === undefined ? undefined : (value.rotations.map(IntegerOptionToJSON)),
        'formats': value.formats === undefined ? undefined : (value.formats.map(StringOptionToJSON)),
        'metaData': MetaDataToJSON(value.metaData),
        'screenPositions': value.screenPositions === undefined ? undefined : (value.screenPositions.map(StringOptionToJSON))
    };
}
